<div class="d-flex justify-content-center mt-4 mb-4">
  <img
    [src]="'imgs/not-found.png'"
    alt="Página não encontrada"
    class="img-thumbnail rounded mx-auto d-block w-50"
  />
</div>
